import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { replaceBaseUrl, pageContext } from 'ctm-util-functions';
import { MechaButton } from 'ctm-components/components/mecha_components/mecha_button/mecha_button';
import { verticalMediaContentSelector } from 'ctm-selectors';

const Container = styled.div`
    max-width: 56rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const ImageWrapper = styled.div`
    width: 16rem;
    img {
        object-fit: contain;
        width: 100%;
    }
    margin-bottom: 3.2rem;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0.8rem;
    margin-bottom: 4.8rem;
`;

const TitleText = styled.span`
    color: #001464;
    font-size: ${(props) => (props.isXs ? '2rem' : '2.8rem')};
    font-style: normal;
    font-weight: 600;
    line-height: 136%;
    text-align: center;
`;

const SubtitleText = styled.span`
    color: #001443;
    text-align: center;
    font-size: ${(props) => (props.isXs ? '1.3rem' : '1.6rem')};
    font-style: normal;
    font-weight: 500;
    line-height: 170%;
`;

const ErrorPageQuote = ({ isXs, href }) => {
    const wentWrongImgUrl = useSelector((state) => verticalMediaContentSelector(state).get('error_page_quote_something_went_wrong_image_url'));
    const dispatch = useDispatch();
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();

    const browserHistory = pageContext.getProps().browserHistory;

    const updatePleaseWait = (value) => dispatch({
        type: 'SET_PAGE_VALUE',
        identifier: 'showPleaseWait',
        value
    });
    const showApiActionError = (value) => dispatch({
        type: 'SET_PAGE_VALUE',
        value,
        identifier: 'displayErrorPageWithNewQuoteButton'
    });
    const updatePageValue = (identifier, value) => dispatch({
        type: 'SET_PAGE_VALUE',
        identifier,
        value
    });

    return (
        <Container dataId={'error_page_container'}>
            <ImageWrapper>
                {wentWrongImgUrl !== null && (<img src={replaceBaseUrl(wentWrongImgUrl, baseAssetsPath)} alt="Ooops something went wrong!" />)}
            </ImageWrapper>
            <TextContainer>
                <TitleText isXs={isXs}>
                    Hmmm..
                    {isXs && <br />}
                    looks like there's a problem
                </TitleText>
                <SubtitleText isXs={isXs}>Click below to start a new quote.</SubtitleText>
            </TextContainer>
            <MechaButton
                dataId={'error_page_new_quote_btn'}
                buttonLabel="Start a new quote"
                buttonSize="lg"
                buttonStyle="primary"
                buttonType="error"
                isDisabled={false}
                href={href}
                onClick={(e) => {
                    e.preventDefault();
                    browserHistory.replace('/car-insurance/journey/start');
                    showApiActionError(false);
                    updatePleaseWait(false);
                    updatePageValue('prefillJourney', false);
                    updatePageValue('hasSeenConfirmation', false);
                }}
            />
        </Container>
    );
};

ErrorPageQuote.propTypes = {
    isXs: PropTypes.bool,
    href: PropTypes.string
};

export { ErrorPageQuote };
